<template>
  <el-container id="appsaude">
    <el-main class="center">
      <el-row>
        <img class="logo-mosia" src="@/assets/images/logo_mosia@2x.png"/>
      </el-row>
      <el-row class="text">
        <img class="logo-sandbox" src="@/assets/images/iTunesArtwork.png"/>
        <span class="title">Mosia Omnichannel - Sandbox</span>
        <p class="info-text">
          Instale gratuitamente nosso aplicativo de demonstrações e
          configure sua central de atendimento. É necessário entrar
          com suas credenciais Mosia Omnichannel.
        </p>
      </el-row>
      <el-row>
          <el-col class="align-div" :span="12">
            <a :href="returnUrlAndroid">
              <img class="download" src="@/assets/images/badge_google.png">
            </a>
            <a class="link" href="">Ajuda Android</a>
          </el-col>
          <el-col class="align-div" :span="12">
            <a v-on:click="redemVoucher">
              <img class="download" src="@/assets/images/badge_apple.png" :style="iosDownloadEnable?'':'opacity:.5'">
            </a>
            <a class="link" href="">Ajuda IOS</a>
          </el-col>
      </el-row>
    </el-main>
    <el-footer style="padding: 0px">
      <el-row>
        <el-col>
          <div :style="`background-image: url(${ require('@/assets/images/footer_wave@2x.jpg')})`" class="footer">
            <div style="display: flex;justify-content: center;margin-top: 63px;align-content: center;align-items: center;">
              <span class="footer-text">v1.0.0&nbsp;-&nbsp;<span id="year">{{returnYear}}</span> - Desenvolvido por</span>
              <img class="logo-mobile" src="@/assets/images/logo_mobile.png">
            </div>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>
<script>
import voucher from '@/api/redemVoucher'
export default {
  data () {
    return {
      iosDownloadEnable: true,
      voucher: ''
    }
  },
  computed: {
    returnYear () {
      return new Date().getFullYear()
    },
    returnUrlAndroid () {
      if (process.env.VUE_APP_DOWNLOAD_ANDROID_ACTIVE === 'true') {
        return process.env.VUE_APP_BASE_LINK_DOWNLOAD_ANDROID
      }
      return ''
    }
  },
  methods: {
    async redemVoucher () {
      if (process.env.VUE_APP_DOWNLOAD_IOS_ACTIVE !== 'true') {
        this.alertUserErro('Download não disponível no momento.')
        return
      }
      const listVoucher = await voucher.getVoucher()
      if (listVoucher.status) {
        window.location.href = process.env.VUE_APP_BASE_LINK_DOWNLOAD_IOS + listVoucher.data.voucher
        return
      }
      this.iosDownloadEnable = false
      this.alertUserErro(listVoucher.message)
      this.voucher = ''
    },
    alertUserErro (msg) {
      let text = msg || 'Não foi possivel instalar nesse momento.'
      alert(text)
    }
  },
  created () {
    if (process.env.VUE_APP_DOWNLOAD_IOS_ACTIVE !== 'true') {
      this.iosDownloadEnable = false
    }
  }
}
</script>
<style lang="less" scoped>
#appsaude {
  height: 100vh;
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .logo-mosia {
    margin-top:50px;
    display: block;

  }
  .title {
    font-family: 'Nunito', sans-serif;
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    color: #000000;
    margin: 0 auto;
    display: block;
  }
  .logo-sandbox {
    height: 200px;
    border: 2px solid #CBE8FF7A;
    border-radius: 30px;
    margin: 71px auto 20px;
    display: block;
  }
  .info-text {
    text-align: center;
    color: #555555;
    font-family: 'Nunito', sans-serif;
    max-width: 500px;
  }
  .logo-mobile {
    width: 105px;
    height: 15px;
    padding-left: 6px
  }
  .link {
    font-family: 'Nunito', sans-serif;
    text-align: center;
    font-size: 14px;
    color: #444CCC;
  }
  .links-download{
    display:flex;
    margin-top: 10px;
  }
  .align-div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .footer {
    height: 91px;
    background-repeat: no-repeat;
    background-size: cover;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .footer-text {
    color: #FFFFFF;
    font-size: 14px;
    font-family: 'Nunito', sans-serif;
  }
  @media only screen and (max-width: 460px) {
    body {
      background: linear-gradient(#E6F2FB, #FFFFFF);
      height: 100vh
    }
    .download {
      height: 60px;
    }
    .footer {
      height: 91px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      position: fixed;
      bottom: 0;
      width: 100%;
    }
    .logo-sandbox {
      height: 140px
    }
    .title {
      font-size: 24px
    }
  }
  @media only screen and (max-width: 1024px) {
    .footer {
      height: 91px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      position: fixed;
      bottom: 0;
      width: 100%;
    }
  }
}
</style>
